import { ReactElement, useMemo } from 'react';
import { LicenseAssignment, UserMembershipView } from '@localstack/types';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';

import { Delete as DeleteIcon } from '@mui/icons-material';

export interface DowngradeLicensesListProps {
  members?: UserMembershipView[];
  licenseAssignments?: LicenseAssignment[];
  loading?: boolean;
  onDeleteLicense: (id: string) => unknown;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
);

export const DowngradeLicensesList = ({
  members,
  licenseAssignments,
  loading,
  onDeleteLicense,
}: DowngradeLicensesListProps): ReactElement => {
  const classes = useStyles();

  type AssignmentLicenses = {
    userName?: string;
    licenseId?: string;
    userId?: string;
  };

  const data = useMemo<AssignmentLicenses[]>(
    () =>
      licenseAssignments?.map((license) => {
        const foundMember = members?.find((member) => member.user_id === license.user_id);
        return {
          userId: license.user_id,
          userName: foundMember?.user_full_name,
          licenseId: license.id,
        };
      }) ?? [],
    [members, licenseAssignments],
  );

  return (
    <List>
      {data.map((entry) => (
        <ListItem key={entry.userId} className={classes.listItem}>
          <ListItemText primary={entry.userName} secondary="License assigned" />
          <ListItemSecondaryAction>
            <IconButton
              color="primary"
              size="small"
              disabled={loading}
              onClick={() => entry.licenseId && onDeleteLicense(entry.licenseId)}
            >
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};
